<blockquote>
    <div class="divider divider-top">
        <img src="/divider.svg" alt="" />
    </div>
    <slot />
</blockquote>
